import axiosInstance from "../axios";

export const getProducts = ({
  searchTerm,
  productIds,
  category,
  spaceDimensions,
  catalogType,
  catalogSubType,
  defaultCatalogs,
}) => {
  return axiosInstance.get(`/products`, {
    params: {
      ...(searchTerm && { search_term: searchTerm }),
      product_ids: productIds,
      ...(category && { category }),
      ...(spaceDimensions && { space_dimensions: spaceDimensions }),
      ...(catalogType && { catalog_type: catalogType }),
      ...(catalogSubType && { catalog_sub_type: catalogSubType }),
      default_catalogs: defaultCatalogs,
    },
  });
};

export const getSectionProducts = ({ searchTerm, sectionType, token , sectionId}) => {
  return axiosInstance.get(`/products/index_with_section_type`, {
    params: {
      ...(searchTerm && { search_term: searchTerm }),
      section_type: sectionType,
      ...(sectionId && { section_id: sectionId }),
      token: token,
    },
  });
};

export const addOrderItemForTempUser = async ({
  product_id,
  projectUUID,
  roomId,
  clearAndAdd,
}) => {
  return axiosInstance.post("/preview", {
    ...(roomId && { room_id: roomId }),
    product_id,
    project_uuid: projectUUID,
    clear_and_add: clearAndAdd,
  });
};

export const getPreviewSections = ({ projectUUID, roomId }) => {
  return axiosInstance.get("/preview", {
    params: {
      ...(roomId && { room_id: roomId }),
      project_uuid: projectUUID,
    },
  });
};

export const createProjectForPreAuthenticateUser = async (token) => {
  return axiosInstance.post("/projects/create_sample", {
    token: token,
  });
};

export const updateOrderItemForTempUser = async ({
  sectionId,
  updatedData,
}) => {
  return axiosInstance.put(`/preview/${sectionId}`, updatedData);
};

export const deleteSection = ({ activeSectionId }) => {
  return axiosInstance.delete("/preview", {
    params: {
      section_id: activeSectionId,
    },
  });
};

export const clearSection = (activeSectionId) => {
  return axiosInstance.delete(`/preview/${activeSectionId}/clear`);
};

export const getCutlistProducts = () => {
  return axiosInstance.get(`/cl`);
};

export const getProduct = ({ productId }) => {
  return axiosInstance.get(`/products/${productId}`);
};

export const getOrderItem = ({ projectId, groupId, orderItemId, version }) => {
  return axiosInstance.get(
    `/projects/${projectId}/groups/${groupId}/load_order_item/${orderItemId}?version=${version}`
  );
};

export const customizeProduct = ({ productId, productOptions }) => {
  return axiosInstance.patch(`/customize_product/${productId}`, {
    selected_option_paths: productOptions,
  });
};

export const customizeOrderItem = ({
  projectId,
  groupId,
  orderItemId,
  productOptions,
  version,
}) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${groupId}/customize_order_item/${orderItemId}`,
    {
      selected_values: productOptions,
      version: version,
    }
  );
};

export const customizeOrderItemDimension = ({
  projectId,
  groupId,
  orderItemId,
  dimension,
  version,
}) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_dimensions`,
    {
      dimension: dimension,
      version: version,
    }
  );
};

export const getGroupCutlist = ({ projectId, groupId }) => {
  return axiosInstance.get(
    `/projects/${projectId}/groups/${groupId}/group_cutlist`
  );
};

export const getOrderItemCutlist = ({
  projectId,
  groupId,
  orderItemId,
  options = null,
}) => {
  return axiosInstance.get(
    `/projects/${projectId}/groups/${groupId}/order_item/${orderItemId}/cutlist`,
    { params: { options } }
  );
};

export const removeProjectOverride = ({
  projectId,
  groupId,
  orderItemIds,
  propertyIdentifier,
}) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${groupId}/remove_project_settings_override`,
    {
      item_ids: orderItemIds,
      property_identifier: propertyIdentifier,
    }
  );
};

export const getOrderItemShutterConfig = ({
  projectId,
  groupId,
  orderItemId,
  options = null,
}) => {
  return axiosInstance.get(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/structural_configs`,
    { params: { options } }
  );
};

export const getOrderItemSpaceConfig = ({
  projectId,
  groupId,
  orderItemId,
  options = null,
}) => {
  return axiosInstance.get(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/structural_configs`,
    { params: { options } }
  );
};

export const updateOrderItemShutterConfig = ({
  projectId,
  groupId,
  orderItemId,
  updateObj,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_shutter_configs`,
    updateObj
  );
};

export const resetOrderItemShutterConfigDimensions = ({
  projectId,
  groupId,
  orderItemId,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/reset_shutter_config_dimensions`
  );
};
export const getRenderMetaData = ({
  projectId,
  groupId,
  orderItemId,
  options = null,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/cabinet_render_meta`,
    { params: { options } }
  );
};

export const updateOrderItemSpaceConfig = ({
  projectId,
  groupId,
  orderItemId,
  updateObj,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_space_config`,
    updateObj
  );
};

export const resetOrderItemSpaceConfig = ({
  projectId,
  groupId,
  orderItemId,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/reset_space_config`
  );
};

export const updateOrderItemSpaceConfigShelves = ({
  projectId,
  groupId,
  orderItemId,
  updateObj,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_shelves`,
    updateObj
  );
};

export const clearOrderItemSpaceConfigShelves = ({
  projectId,
  groupId,
  orderItemId,
  spaceIdentifier,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_shelves`,
    { identifier: spaceIdentifier, shelf: 0 }
  );
};

export const addProducts = ({ productIds, tempIds, projectId, roomId, position }) => {
  return axiosInstance.post(`/order_items`, {
    project_id: projectId,
    room_id: roomId,
    product_ids: productIds,
    position: position,
    ...(tempIds && { temp_ids: tempIds }),
  });
};

export const addAttachmentsToOrderItem = ({
  projectId,
  groupId,
  orderItemId,
  image,
  label,
}) => {
  const formData = new FormData();
  formData.append("attachments", image, label);

  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_item_attachments/${orderItemId}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const updateOrderItemName = ({
  projectId,
  groupId,
  orderItemId,
  orderItemName,
}) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_name`,
    { name: orderItemName }
  );
};

export const updateOrderItemData = ({
  projectId,
  groupId,
  orderItemId,
  orderItemName,
  orderItemUserLabel,
}) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_data`,
    { name: orderItemName, user_label: orderItemUserLabel }
  );
};

export const addRemarksToOrderItem = ({
  projectId,
  groupId,
  orderItemId,
  remarks,
}) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${groupId}/order_item_remarks/${orderItemId}`,
    { remarks }
  );
};
export const deleteAttachment = async ({
  projectId,
  groupId,
  orderItemId,
  blobId,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/remove_order_items_attachment/${orderItemId}/${blobId}`
  );
};

export const getCutlist = ({ productId, options }) => {
  return axiosInstance.get(`/products/${productId}/cutlist`, {
    params: { options: options },
  });
};

export const getLiteProduct = ({ productId }) => {
  return axiosInstance.get(`/products/${productId}/v2/show`);
};

export const updateIndividualShutterColor = async ({
  projectId,
  groupId,
  orderItemId,
  shutterLabel,
  shutterColor,
}) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_individual_shutter_color/`,
    {
      shutter_label: shutterLabel,
      shutter_color: shutterColor,
    }
  );
};

export const addSubModuleToProject = ({ productId, selectedModuleId }) => {
  return axiosInstance.post(`/order_items/${selectedModuleId}/add_sub_module`, {
    product_id: productId,
  });
};

export const addVerticalShutterDivider = ({
  projectId,
  groupId,
  orderItemId,
  path,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/add_vertical_shutter_partitions`,
    {
      path: path,
    }
  );
};

export const addHorizontalShutterDivider = ({
  projectId,
  groupId,
  orderItemId,
  path,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/add_horizontal_shutter_partitions`,
    {
      path: path,
    }
  );
};

export const copyInternalsToSpace = ({
  projectId,
  groupId,
  orderItemId,
  path,
  productId,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/copy_internals_to_space`,
    {
      path: path,
      product_id: productId,
    }
  );
};

export const copyTemplateToSpace = ({
  projectId,
  groupId,
  orderItemId,
  path,
  productId,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/copy_template_to_space`,
    {
      path: path,
      product_id: productId,
    }
  );
};

export const addEqualShelves = ({
  projectId,
  groupId,
  orderItemId,
  shelfCount,
  path,
  removable,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/add_eq_shelves`,
    {
      shelf_count: shelfCount,
      path: path,
      removable: removable,
    }
  );
};

export const addEqualPartitions = ({
  projectId,
  groupId,
  orderItemId,
  verticalCount,
  path,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/add_eq_verticals`,
    {
      verticals_count: verticalCount,
      path: path,
    }
  );
};

export const addAbsoluteShelf = ({
  projectId,
  groupId,
  orderItemId,
  position,
  path,
  removable,
  direction,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/add_shelf_at`,
    {
      position: position,
      path: path,
      removable: removable,
      direction: direction,
    }
  );
};

export const addAbsoluteVerticals = ({
  projectId,
  groupId,
  orderItemId,
  position,
  path,
  direction,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/add_vertical_at`,
    {
      position: position,
      path: path,
      direction: direction,
    }
  );
};

export const deletePartition = ({ projectId, groupId, orderItemId, path }) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/delete_partition`,
    {
      path: path,
    }
  );
};

export const updatePartitionComponent = ({
  projectId,
  groupId,
  orderItemId,
  path,
  componentIdentifier,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_partition_component`,
    {
      path: path,
      component_identifier: componentIdentifier,
    }
  );
};

export const clearSpace = ({ projectId, groupId, orderItemId, path }) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/clear_space`,
    { path: path }
  );
};

export const clearRootSpace = ({ projectId, groupId, orderItemId }) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/clear_mutable_partitions`,
    {}
  );
};

export const updateSpaceSize = ({
  projectId,
  groupId,
  orderItemId,
  path,
  height,
  width,
}) => {
  const payload = {
    path: path,
  };

  if (height !== null && height !== undefined) {
    payload.height = height;
  }

  if (width !== null && width !== undefined) {
    payload.width = width;
  }

  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_space_size`,
    payload
  );
};

export const updateShutter = ({ projectId, groupId, orderItemId, payload }) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/update_shutter`,
    payload
  );
};

export const removeShutter = ({ projectId, groupId, orderItemId, payload }) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/remove_shutter`,
    payload
  );
};

export const addShutter = ({ projectId, groupId, orderItemId, payload }) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/add_shutter`,
    payload
  );
};

export const getRoomViewContext = ({ projectId, roomId }) => {
  return axiosInstance.get(
    `/projects/${projectId}/rooms/${roomId}/primary_view`
  );
};

export const updateGroupPosition = ({ projectId, groupId, new_position }) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/update_position`,
    {
      new_position,
    }
  );
};

export const saveObjectPositions = ({ projectId, roomId, items }) => {
  return axiosInstance.put(
    `/projects/${projectId}/rooms/${roomId}/move_items`,
    {
      items: items,
    }
  );
};

export const copyItems = ({ projectId, roomId, items, target }) => {
  return axiosInstance.post(
    `/projects/${projectId}/rooms/${roomId}/copy_items`,
    {
      items: items,
      target: target,
    }
  );
};

export const copyItemsV2 = ({ projectId, roomId, items, target }) => {
  return axiosInstance.post(
    `/projects/${projectId}/rooms/${roomId}/copy_items_v2`,
    {
      items: items,
      target: target,
    }
  );
};

export const cutItems = ({ projectId, roomId, items, target }) => {
  return axiosInstance.put(`/projects/${projectId}/rooms/${roomId}/cut_items`, {
    items: items,
    target: target,
  });
};

export const addWall = ({ projectId, roomId }) => {
  return axiosInstance.post(`/projects/${projectId}/walls`, {
    room_id: roomId,
  });
};

export const updateWallSize = ({ projectId, wallId, height, width }) => {
  const payload = {};

  if (height !== null && height !== undefined) {
    payload.height = height;
  }
  if (width !== null && width !== undefined) {
    payload.width = width;
  }
  return axiosInstance.put(
    `/projects/${projectId}/walls/${wallId}/update_dimensions`,
    payload
  );
};

export const updateWallName = ({ projectId, wallId, name }) => {
  const payload = { name: name };

  return axiosInstance.put(
    `/projects/${projectId}/walls/${wallId}/update_name`,
    payload
  );
};

export const deleteWall = ({ projectId, wallId }) => {
  return axiosInstance.delete(`/projects/${projectId}/walls/${wallId}`);
};

export const deleteItems = ({ projectId, roomId, items }) => {
  return axiosInstance.put(
    `/projects/${projectId}/rooms/${roomId}/delete_items`,
    {
      items: items,
    }
  );
};

export const mergeShutters = ({ projectId, groupId, orderItemId, payload }) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${groupId}/order_items/${orderItemId}/merge_shutters`,
    payload
  );
};

export const alignItems = ({ projectId, roomId, items }) => {
  return axiosInstance.put(
    `/projects/${projectId}/rooms/${roomId}/align_items`,
    {
      items,
    }
  );
};

export const replaceModuleTemplate = ({
  projectId,
  orderItemId,
  productId,
}) => {
  return axiosInstance.put(
    `/projects/${projectId}/groups/${null}/order_items/${orderItemId}/change_product`,
    {
      product_id: productId,
    }
  );
};

export const editLight = ({ projectId, orderItemId, light }) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${null}/order_items/${orderItemId}/save_light`,
    {
      light,
    }
  );
};

export const deleteLight = ({ projectId, orderItemId, uniqId }) => {
  return axiosInstance.patch(
    `/projects/${projectId}/groups/${null}/order_items/${orderItemId}/delete_light`,
    {
      uniq_id: uniqId,
    }
  );
};
